module.exports = __webpack_public_path__ + "public/img/bkl_Loading.b3679740.gif";